import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type StandConnectionStatus = 'no_answer' | 'connected' | 'disconnected'

export interface ServerState {
  serverConnected: boolean;
  standConnectionStatus: StandConnectionStatus;
  serverConnectionEstablishing: boolean;
}

const initialState: ServerState = {
  serverConnected: false,
  standConnectionStatus: 'disconnected',
  serverConnectionEstablishing: false,
};

export const serverSlice = createSlice({
  name: "server",
  initialState,
  reducers: {
    setServerConnection: (state, action: PayloadAction<boolean>) => {
      state.serverConnected = action.payload;
    },
    setStandConnectionStatus: (state, action: PayloadAction<StandConnectionStatus>) => {
      state.standConnectionStatus = action.payload;
    },
    setServerConnectionEstablishing: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.serverConnectionEstablishing = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setServerConnection,
  setStandConnectionStatus,
  setServerConnectionEstablishing,
  reset: resetServerConnectionState,
} = serverSlice.actions;

export default serverSlice.reducer;
